import { Theme } from '@emotion/react';
import { SxProps } from '@mui/system';

export const styles = {
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    mb: 2,
    paddingTop: '16px',
    paddingBottom: '24px',
  },
  headerFont: {
    fontSize: 18,
    fontWeight: 600,
  },
  filterContainer: {
    mb: 1,
  },
  autocomplete: {
    ml: 1,
    '& .MuiFormControl-root': {
      backgroundColor: 'secondary.main',
    },
  },
} satisfies Record<string, SxProps<Theme>>;
